<div class="row mb-4">
  <div class="bottom-table-head">
    <h4>Sponsor Details</h4>
    <p-button
      label="Add Sponsor"
      [disabled]="totalCollected === projectCost"
      (click)="donorsSidebarVisible = true"
      *appHasRole="[1, 3, 2]"
    />
  </div>

  <div class="justify-content-start flex-wrap mt-15">
    <p-table [value]="doners" class="tab-data-table">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="firstName" class="text-center">
            Sponsor Name<p-sortIcon field="firstName" />
          </th>
          <th pSortableColumn="phoneNumber" class="text-center">
            Phone <p-sortIcon field="phoneNumber" />
          </th>

          <th pSortableColumn="email" class="text-center">
            Email <p-sortIcon field="email" />
          </th>
          <th pSortableColumn="address" class="text-center">
            Address <p-sortIcon field="address" />
          </th>
          <th pSortableColumn="memoryOf" class="text-center">
            Memory of <p-sortIcon field="memoryOf" />
          </th>
          <th pSortableColumn="Amount" class="text-right">
            Amount <p-sortIcon field="Amount" />
          </th>
          <th pSortableColumn="Payment" class="text-center">
            Mode of Payment <p-sortIcon field="Payment" />
          </th>
          <th >Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-donor>
        <tr>
          <td class="text-center">
            {{ donor.firstName }} {{ donor.lastName }}
          </td>
          <td class="text-center">
            {{ donor.phoneNumber }}
          </td>
          <td class="text-center">{{ donor.email }}</td>
          <td class="text-center">{{ donor.address }}</td>
          <td class="text-center">{{ donor.memoryOf }}</td>
          <td class="text-right">
            {{ donor.amount | currency : "INR" : "symbol" : "1.0-0" }} /-
          </td>
          <td class="text-right">
            {{ donor.ModeofPayment }}
          </td>
          <td>

            <div class="d-flex gap-3 action-btns">
              <img src="assets/images/icon-edit.svg" (click)="onEditSponsors(donor)" *appHasRole="[3]">
              <img src="assets/images/icon-delete.svg" (click)="onDelete(donor)" *appHasRole="[3]">
            </div>

           
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center">No Sponsors Found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="donorsSidebarVisible"
  position="right"
  [showCloseIcon]="false"
>
  <form
    [formGroup]="donorForm"
    *ngIf="donorsSidebarVisible"
    (ngSubmit)="updatedonorForm()"
  >
    <div class="tab-pop-txt">
      <h4>{{ donorsAddEditText }}</h4>
      <i class="pi pi-times" (click)="donorsSidebarVisible = false"></i>
    </div>

    <div class="pop-data-set">
      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">First Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="DonorsFirstName"
            formControlName="DonorsFirstName"
            aria-describedby="DonorsFirstName"
          />
          <small
            *ngIf="
              donorForm.get('DonorsFirstName').invalid &&
              donorForm.get('DonorsFirstName').touched
            "
            class="p-error"
          >
            First Name is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Last Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="DonorsLastName"
            formControlName="DonorsLastName"
            aria-describedby="DonorsLastName"
          />
          <small
            *ngIf="
              donorForm.get('DonorsLastName').invalid &&
              donorForm.get('DonorsLastName').touched
            "
            class="p-error"
          >
            Last Name is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Phone</div>
        <div class="project-detail-set-v mt-2">
          <p-inputNumber
            id="DonorsPhone"
            mode="decimal"
            [useGrouping]="false"
            formControlName="DonorsPhone"
            aria-describedby="DonorsPhone"
          ></p-inputNumber>
          <small
            *ngIf="
              donorForm.get('DonorsPhone').invalid &&
              donorForm.get('DonorsPhone').touched
            "
            class="p-error"
          >
            Valid phone number is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">e-mail</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="DonorsEmail"
            formControlName="DonorsEmail"
            aria-describedby="DonorsEmail"
          />
          <small
            *ngIf="
              donorForm.get('DonorsEmail').invalid &&
              donorForm.get('DonorsEmail').touched
            "
            class="p-error"
          >
            Valid email is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Address</div>
        <div class="project-detail-set-v mt-2">
          <textarea
            rows="5"
            cols="30"
            pInputTextarea
            id="DonorsAddress"
            aria-describedby="DonorsAddress"
            formControlName="DonorsAddress"
          ></textarea>
          <small
            *ngIf="
              donorForm.get('DonorsAddress').invalid &&
              donorForm.get('DonorsAddress').touched
            "
            class="p-error"
          >
            Address is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Memory of</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="DonorsMemoryOf"
            aria-describedby="DonorsMemoryOf"
            formControlName="DonorsMemoryOf"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Amount</div>
        <div class="project-detail-set-v mt-2">
          <p-inputNumber
            id="DonorsAmount"
            mode="decimal"
            locale="en-IN"
            [min]="1"
            [max]="remainingAmount"
            [minFractionDigits]="2"
            formControlName="DonorsAmount"
          ></p-inputNumber>
          <small
            *ngIf="
              donorForm.get('DonorsAmount').invalid &&
              donorForm.get('DonorsAmount').touched
            "
            class="p-error"
          >
            Valid amount is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Mode of Payment (Cash / Online)</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="DonorsModeofPayment"
            aria-describedby="DonorsModeofPayment"
            formControlName="DonorsModeofPayment"
          />
          <small
            *ngIf="
              donorForm.get('DonorsModeofPayment').invalid &&
              donorForm.get('DonorsModeofPayment').touched
            "
            class="p-error"
          >
            Payment mode is required
          </small>
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">upload Profile Image</div>
        <div class="project-detail-set-v mt-2">
          <input type="file" (change)="onUpload($event)" accept="image/*" />
        </div>
      </div>
    </div>

    <div class="tab-footer-btns">
      <p-button
        label="Cancel "
        (click)="donorsSidebarVisible = false"
        class="cancel-btn"
      />
      <p-button label="Add " type="submit" class="submit-btn" />
    </div>
  </form>
</p-sidebar>
